<template>
  <div>
    <!-- 失败记录弹窗 -->
    <el-dialog :visible.sync="exportVisible"
               :close-on-click-modal='false'
               :before-close="cancelFail"
               title="失败记录"
               width="990px">
      <el-form :model="dataForm3"
               :inline="true"
               ref="dataForm2"
               class="demo-form-inline"
               label-width="160px">
        <el-row class="row-btn">
          <el-button @click="handleFailExport()">导出</el-button>
        </el-row>
        <el-table :data="dataFailedList"
                  border
                  v-loading="dataListLoading"
                  style="width: 100%;">
          <el-table-column type="index"
                           label="序号"
                           width="50"></el-table-column>
          <el-table-column prop="oldGoodsCode"
                           header-align="center"
                           align="left"
                           width="150"
                           label="物品编码">
          </el-table-column>
          <el-table-column prop="oldSpecification"
                           header-align="center"
                           align="left"
                           label="规格">
          </el-table-column>
          <el-table-column prop="oldModel"
                           header-align="center"
                           align="left"
                           label="型号">
          </el-table-column>
          <el-table-column prop="goodsNum"
                           header-align="center"
                           align="center"
                           label="领用数量">
          </el-table-column>
          <el-table-column prop="msg"
                           header-align="center"
                           align="center"
                           label="失败原因">
          </el-table-column>
        </el-table>
        <el-pagination background
                       style="margin-top:10px;text-align: center;"
                       layout="prev, pager, next, total, jumper, slot"
                       prev-text="上一页"
                       next-text="下一页"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="currentPage"
                       :page-size="10"
                       :pager-count="5"
                       :total="total"></el-pagination>
      </el-form>
      <div class="addFunc">
        <div class="addCancel"
             @click="cancelFail">
          <i class="el-icon-loading"
             v-if="subLoading"></i>取消
        </div>
        <!-- <div class="addConfirm" :class="subLoading?'but-loading':''" @click="confirmPush">
            <i class="el-icon-loading" v-if="subLoading"></i>
            确定
        </div> -->
      </div>
    </el-dialog>
    <el-dialog :visible.sync="searchVisible"
               :close-on-click-modal='false'
               :before-close="cancelGoods"
               title="备件选择"
               width="990px">
      <el-form :model="dataForm2"
               :inline="true"
               ref="dataForm2"
               class="demo-form-inline"
               label-width="160px">
        <el-row>
          <el-col :span="10">
            <el-form-item label="用户物品编码："
                          prop="custGoodsCode">
              <label>
                <el-input v-model="dataForm2.custGoodsCode"
                          placeholder="请输入用户物品编码"
                          style="width:180px !important"
                          clearable></el-input>
              </label>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="物品型号："
                          prop="model">
              <label>
                <el-input v-model="dataForm2.model"
                          placeholder="请输入物品型号"
                          style="width:180px !important"
                          clearable></el-input>
              </label>
            </el-form-item>
          </el-col>
          <el-button @click="handleCode()">查询</el-button>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="物品规格："
                          prop="userMobile">
              <label>
                <el-input v-model="dataForm2.specification"
                          placeholder="请输入物品规格"
                          style="width:180px !important"
                          clearable></el-input>
              </label>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="物品名称："
                          prop="userMobile">
              <label>
                <el-input v-model="dataForm2.goodsName"
                          placeholder="请输入物品名称"
                          style="width:180px !important"
                          clearable></el-input>
              </label>
            </el-form-item>
          </el-col>
          <el-button @click="handleReset()">重置</el-button>
        </el-row>
        <el-table ref="multipleTable"
                  :data="goodsList"
                  border
                  v-loading="dataListLoading"
                  @selection-change="selectionChangeHandle"
                  @row-dblclick="handledbClick"
                  style="width: 100%;">
          <el-table-column type="selection"
                           width="55"></el-table-column>
          <el-table-column type="index"
                           label="序号"
                           width="50"></el-table-column>
          <el-table-column prop="oldGoodsCode"
                           header-align="center"
                           align="left"
                           label="物品编码"
                           width="150">
          </el-table-column>
          <el-table-column prop="oldGoodsName"
                           header-align="center"
                           align="left"
                           label="物品名称">
          </el-table-column>
          <el-table-column prop="oldSpecification"
                           header-align="center"
                           align="left"
                           label="规格"
                           width="100">
          </el-table-column>
          <el-table-column prop="oldModel"
                           header-align="center"
                           align="left"
                           label="型号">
          </el-table-column>
          <!-- <el-table-column prop="oldEdition"
                           header-align="center"
                           align="center"
                           label="版本">
          </el-table-column> -->
          <!-- <el-table-column prop="oldConfiguration"
                           header-align="center"
                           align="center"
                           label="配置">
          </el-table-column> -->
          <el-table-column prop="oldBrand"
                           header-align="center"
                           align="center"
                           label="品牌">
          </el-table-column>
          <el-table-column prop="sellingUnit"
                           header-align="center"
                           align="center"
                           label="单位">
          </el-table-column>
          <el-table-column prop="oldRemark"
                           header-align="center"
                           align="center"
                           label="备注">
          </el-table-column>
          <!-- <el-table-column fixed="right" header-align="center" align="center" label="操作" width="80">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="confirmAdd(scope.row)">选择</el-button>
        </template>
      </el-table-column> -->
        </el-table>
      </el-form>
      <div class="addFunc">
        <div class="addCancel"
             @click="cancelGoods">取消</div>
        <div class="addCancel addConfirm"
             @click="confirmPush">
          选择
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="visible"
               :close-on-click-modal='false'
               :before-close="cancelAdd"
               title="领用超量原因"
               width="800px">
      <el-form :model="dataForm"
               :inline="true"
               ref="dataForm"
               :rules="dataRule"
               label-width="160px"
               class="demo-form-inline">
        <el-row>
          <el-col :span="24">
            <el-form-item label="请填写领用超量原因："
                          prop="userName">
              <label>
                <el-input type="textarea"
                          maxlength="200"
                          placeholder="当前领用数量高于备件数量，请输入领用超量原因(不超过200字)..."
                          v-model="exceedReason"
                          style="width:500px !important"
                          :rows="3"></el-input>
              </label>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="btns">
          <el-button type="primary"
                     class="btn-check"
                     @click="handleSaveReason()"
                     :class="subLoading?'but-loading':''">确认</el-button>
          <el-button type="primary"
                     @click="cancelAdd()"
                     :class="subLoading?'but-loading':''">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
    <div class="container">
      <!-- 面包屑 -->
      <div class="integralBreadcrumb">
        <div class="integralBreadcrumb-item"
             @click="routerHandle('basicInfo')">个人中心</div>
        <div class="el-icon-arrow-right jt"></div>
        <div class="integralBreadcrumb-item"
             @click="routerHandle('spareGetList')">联储联备</div>
        <div class="el-icon-arrow-right jt"></div>
        <div class="integralBreadcrumb-item"
             @click="routerHandle('spareGetList')">备件领用</div>
        <div class="el-icon-arrow-right jt"></div>
        <div class="integralBreadcrumb-item">备件领用单新增</div>
      </div>
      <div class="sjz">
        <div :class="index===(steps.length-1)?'sjz-item':'sjz-kuaikuai'"
             v-for="(item, index) in steps"
             :key="index">
          <div class="sjz-item">
            <div :class="'sjz-icon '+ ((index>activeIndex)?'sjz-undone':(index===activeIndex)?'sjz-do':'')">
              <i class="el-icon-check"
                 style="width:40px;height:40px;"
                 v-if="index<activeIndex"></i>
              <span class="sjc-num sjc-do"
                    v-else-if="index===activeIndex">{{index+1}}</span>
              <span class="sjc-num"
                    v-else-if="index>activeIndex">{{index+1}}</span>
            </div>
            <div class="sjz-word">{{item.name}}</div>
          </div>
          <div :class="'sjz-line '+((index>=activeIndex)?'sjz-undone':'')"
               v-if="index!==(steps.length-1)"></div>
        </div>
      </div>
      <div class="body-info">
        <el-form :model="dataForm"
                 :inline="true"
                 ref="dataForm"
                 :rules="dataRule"
                 label-width="160px"
                 class="demo-form-inline">
          <address-detail @myEvent="handleAddress"></address-detail>
          <div style="position:relative;">
            <!-- <h3 style="display: inline-block;" class="spareInfo">填写领用单</h3> -->
            <!-- <span style="position:absolute;right:30px;top:10px;padding:5px 20px;border: 1px solid #1D65A8;border-radius: 15px;font-size: 14px;color: #333333;">
          领用单状态：
        </span> -->
          </div>
          <!-- <el-row v-if="userInfo">
        <el-col :span="12">
          <el-form-item label="客户负责人：" prop="userMobile">
            <label>{{userInfo.customerLeaderName}}</label>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="userInfo">
        <el-col :span="12">
          <el-form-item label="联系电话：" prop="userCompany">
            <label>{{ userInfo.customerLeaderMobile }}</label>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="公司名称：" prop="userCompany">
            <label>{{ userInfo.customerName }}</label>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="领用日期：" prop="userCompany">
            <label>
              <el-date-picker
                v-model="currentDate"
                type="date"
                :disabled="true"
                placeholder="选择日期">
              </el-date-picker>
            </label>
          </el-form-item>
        </el-col>
      </el-row> -->
          <h3 style="display: inline-block;"
              class="spareInfo">领用物品</h3>
          <el-row class="two-btns">
            <el-button type="primary"
                       style="background:#1D65A8;color:#fff;border-color:#1D65A8"
                       @click="addNew()">手工增行</el-button>
            <el-button type="primary"
                       style="background:#1D65A8;color:#fff;border-color:#1D65A8"
                       @click="importInfo()">备件领用信息上传</el-button>
            <input type="file"
                   class="info-but but-file"
                   ref="inputer"
                   v-show="false"
                   @change="importf()"
                   accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
            <el-upload v-show="false"
                       ref="fielUplod"
                       :on-success="fileSuccess"
                       :on-error="fileError"
                       accept="csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                       :headers="headerMsg"
                       :action="upLoadUrl">
              <el-button type="primary">上传文件</el-button>
            </el-upload>
            <el-button type="primary"
                       style="background:#1D65A8;color:#fff;border-color:#1D65A8;margin-left:10px"
                       @click="handleExportFailed()">导出失败信息</el-button>
            <span class="downloadTem"
                  @click="downloadTemplate()">上传模板下载</span>
          </el-row>
          <el-row style="margin-bottom:10px;">
            <el-table :data="dataList"
                      border
                      v-loading="dataListLoading"
                      style="width: 100%;">
              <el-table-column type="index"
                               width="50"
                               label="序号"></el-table-column>
              <el-table-column prop="oldGoodsCode"
                               header-align="center"
                               align="center"
                               label="物品编码"
                               width="150"
                               class="goodsCode">
                <template slot-scope="scope">
                  <el-autocomplete :minlength="2"
                                   v-model="scope.row.oldGoodsCode"
                                   :fetch-suggestions="querySearchAsync"
                                   placeholder="请输入内容"
                                   @input="(e) => handleChange(e, scope, scope.$index)"
                                   @select="handleSelect($event, scope.$index)"
                                   style="width:120px !important;"
                                   popper-class="my-kqoption-spareGet"
                                   :maxlength="20"></el-autocomplete>
                  <i class="el-icon-search"
                     @click="openDialogHandle(scope.row,scope.$index)"></i>
                </template>
              </el-table-column>
              <el-table-column prop="oldGoodsName"
                               header-align="center"
                               align="center"
                               label="物品名称"
                               show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="oldSpecification"
                               header-align="center"
                               align="center"
                               label="规格"
                               show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="oldModel"
                               header-align="center"
                               align="center"
                               label="型号"
                               show-overflow-tooltip>
                <!-- <template slot-scope="scope">
              <el-input placeholder="请输入型号" v-model="scope.row.model" :disabled="true"></el-input>
          </template> -->
              </el-table-column>
              <!-- <el-table-column prop="oldEdition"
                               header-align="center"
                               align="center"
                               label="版本"
                               show-overflow-tooltip> -->
                <!-- <template slot-scope="scope">
              <el-input placeholder="请输入版本" v-model="scope.row.edition" :disabled="true"></el-input>
          </template> -->
              <!-- </el-table-column> -->
              <!-- <el-table-column prop="oldConfiguration"
                               header-align="center"
                               align="center"
                               label="配置"
                               show-overflow-tooltip>
              </el-table-column> -->
              <el-table-column prop="oldBrand"
                               header-align="center"
                               align="center"
                               label="品牌"
                               show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="sellingUnit"
                               header-align="center"
                               align="center"
                               label="单位"
                               show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="goodsPrice"
                               header-align="center"
                               align="center"
                               label="单价"
                               show-overflow-tooltip>
                <!-- <template slot-scope="scope">
              <el-input placeholder="请输入配置" v-model="scope.row.configuration" :disabled="true"></el-input>
          </template> -->
              </el-table-column>
              <el-table-column prop="oldRemark"
                               header-align="center"
                               align="center"
                               label="备注"
                               show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-input placeholder="请输入备注"
                            v-model="scope.row.oldRemark"
                            clearable
                            maxlength="300"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="safetyStockQuantity"
                               header-align="center"
                               align="center"
                               label="备件数量"
                               show-overflow-tooltip>
                <!-- <template slot-scope="scope">
              <el-input placeholder="请输入备件数量" v-model="scope.row.safetyStockQuantity" :disabled="true" clearable></el-input>
          </template> -->
              </el-table-column>
              <el-table-column prop="goodsNum"
                               header-align="center"
                               align="center"
                               label="领用数量"
                               show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-input placeholder="请输入领用数量"
                            maxlength="7"
                            v-model="scope.row.goodsNum"
                            clearable></el-input>
                </template>
              </el-table-column>
              <el-table-column fixed="right"
                               header-align="center"
                               align="center"
                               label="操作"
                               width="80">
                <template slot-scope="scope">
                  <!-- <el-button type="text" size="small" @click="openDialogHandle(scope.row,scope.$index)">检索物料</el-button> -->
                  <el-button type="text"
                             size="small"
                             @click="deleteHandle(scope.row,scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <h3 style="display: inline-block;margin-top:20px;"
                class="spareInfo">领用时间</h3>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="期望领用日期："
                            prop="expectDeliveryDate">
                <label>
                  <el-date-picker v-model="dataForm.expectDeliveryDate"
                                  type="date"
                                  placeholder="选择日期"
                                  value-format="yyyy-MM-dd"
                                  :picker-options="pickerOptions1"
                                  clearable>
                  </el-date-picker>
                </label>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
          <el-form-item label="是否加急：" prop="userCompany">
            <label>
                <el-radio v-model="dataForm.expedited" label="1">是</el-radio>
                <el-radio v-model="dataForm.expedited" label="0">否</el-radio>
            </label>
          </el-form-item>
        </el-col> -->
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注："
                            prop="userMobile">
                <label>
                  <el-input type="textarea"
                            maxlength="200"
                            v-model="dataForm.remarks"
                            placeholder="请输入备注(不超过200字)..."
                            style="width:600px !important;"
                            :rows="3"></el-input>
                </label>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="row"
               style="display:flex;justify-content: center;margin-top:20px">
            <div :class="'row-opt-but ' +(subLoading?'but-loading':'')"
                 style="margin-right:10px;"
                 @click="routerHandle('spareGetList')">
              <i class="el-icon-loading"
                 v-if="subLoading"></i>
              取消
            </div>
            <div :class="'row-opt-but ' +(subLoading?'but-loading':'')"
                 style="background-color:#1D65A8;color:#fff"
                 @click="handleSave()">
              <i class="el-icon-loading"
                 v-if="subLoading"></i>
              确定
            </div>
          </div>
        </el-form>
        <span slot="footer"
              class="dialog-footer">
        </span>
      </div>
      <el-dialog title="批量导入失败原由"
                 :close-on-click-modal="false"
                 :visible.sync="importVisible"
                 width='530px'>
        <div v-html="errorContent"></div>
        <span slot="footer">
          <div class="butt close-but"
               @click="importVisible=false;errorContent=''">确定</div>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import AddressDetail from './addressDetail.vue'
import { getAccessToken } from '@/utils/userInfo'
import axios from 'axios'
export default {
  name: 'test-keep-alive',
  data () {
    return {
      dataForm: {
        id: '',
        dateValue: '',
        expedited: 1,
        name: '',
        remarks: '',
        expectDeliveryDate: ''
      },
      pickerOptions1: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24
        }
      },
      currentDate: Date.now(),
      customerCode: '',
      addressId: '',
      userInfo: null,
      userId: '',
      nameList: [],
      addressList: [
        { name: 'XXX', address: '辽宁省大了事', phone: '15110989898' },
        { name: 'XXX1', address: '辽宁省大了事', phone: '15110989898' },
        { name: 'XXX12', address: '辽宁省大了事', phone: '15110989898' }
      ],
      gogo: true,
      visible: false,
      exceedReason: '',
      dataList: [],
      dataListLoading: false,
      dataListSelections: [],
      subLoading: false, // 按钮加载中
      subFlag: false, // 提交成功
      dataRule: {
        expectDeliveryDate: [
          {
            required: true,
            message: '期望领用日期不能为空',
            trigger: 'change'
          }
        ]
      },
      oweFeeFlag: '',
      searchVisible: false,
      dataForm2: {
        specification: '',
        edition: '',
        goodsName: '',
        custGoodsCode: '', // 用户物品编码
        model: '' // 型号
      },
      goodsList: [],
      currentIndex: '',
      activeIndex: 0,
      steps: [
        {
          ind: 1,
          key: '',
          name: '提交领用'
        },
        {
          ind: 2,
          key: '',
          name: '仓储受理'
        },
        {
          ind: 3,
          key: '',
          name: '物流配送'
        },
        {
          ind: 4,
          key: '',
          name: '完成  '
        },
        {
          ind: 5,
          key: '',
          name: '完成评价'
        }
      ],
      importVisible: false, // 导入弹框
      upLoadUrl: '',
      errorContent: '',
      headerMsg: { Authorization: 'Bearer ' + getAccessToken() },
      exportVisible: false,
      dataForm3: {
        customerCode: ''
      },
      // 分页
      total: 0,
      currentPage: 1, // 当前页
      pageSize: 10,
      dataFailedList: []
    }
  },
  mounted () {
    let companyId = this.$store.state.user.company.companyId === undefined ? null : this.$store.state.user.company.companyId
    this.upLoadUrl = window.SITE_CONFIG['apiURL'] + `/front/order/lclb/receive/importRByOrdinary?companyId=` + companyId
    // this.getUserInfo()
  },
  components: {
    AddressDetail
  },
  methods: {
    // 查询物料信息
    openDialogHandle (row, index) {
      this.dataForm2.specification = ''
      this.dataForm2.edition = ''
      this.dataForm2.configuration = []
      this.dataForm2.goodsName = ''
      this.goodsList = []
      this.currentIndex = index
      this.searchVisible = true
      this.handleCode()
    },
    cancelGoods () {
      this.searchVisible = false
    },
    handleCode () {
      this.dataListLoading = true
      let params = {
        companyId: this.$store.state.user.company.companyId === undefined ? null : this.$store.state.user.company.companyId,
        oldSpecification: this.dataForm2.specification,
        oldGoodsName: this.dataForm2.goodsName,
        oldGoodsCode: this.dataForm2.custGoodsCode,
        oldModel: this.dataForm2.model
      }
      this.$http.post(`/front/order/lclb/receive/getSparePartsDetailByOrdinary`, params)
        .then(({ data: res }) => {
          this.goodsList = res.data
          this.dataListLoading = false
        })
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    },
    confirmAdd (row) {
      let goodsCode = row.oldGoodsCode
      let goodsName = row.oldGoodsName
      let specification = row.oldSpecification
      let model = row.oldModel
      let edition = row.oldEdition
      let configuration = row.oldConfiguration
      let safetyStockQuantity = row.safetyStockQuantity
      let goodsPrice = row.goodsPrice
      let brand = row.oldBrand
      let remark = row.oldRemark
      let custspId = row.custspId
      this.dataList[this.currentIndex].oldConfiguration = configuration
      this.dataList[this.currentIndex].oldEdition = edition
      this.dataList[this.currentIndex].oldGoodsCode = goodsCode
      this.dataList[this.currentIndex].oldGoodsName = goodsName
      this.dataList[this.currentIndex].oldSpecification = specification
      this.dataList[this.currentIndex].oldModel = model
      this.dataList[this.currentIndex].oldBrand = brand
      this.dataList[this.currentIndex].safetyStockQuantity = safetyStockQuantity
      this.dataList[this.currentIndex].goodsPrice = goodsPrice
      this.dataList[this.currentIndex].oldRemark = remark
      this.dataList[this.currentIndex].custspId = custspId
      this.dataList = [...this.dataList]
      this.searchVisible = false
    },
    // 获取当前登录信息
    getUserInfo () {
      this.$http
        .get(`${window.SITE_CONFIG['apiURL']}/sys/user/info`)
        .then((data) => {
          // console.log(data)
          if (data && data.code === '1') {
            this.userInfo = data.result.user
            this.userId = data.result.user.userId
            this.customerCode = data.result.user.customerCode
            this.oweFeeFlag = data.result.user.oweFeeFlag
            this.getNameList()
          }
        })
    },
    // 跳转页面,取消返回
    routerHandle (name, pName) {
      if (name) {
        // if (name === 'spareGetList'){
        //    this.$router.push({name:'spareGetList'})
        // } else {
        this.$router.push({ name: name })
        // }
      } else {
        this.resetData()
        this.$router.go(-1)
      }
    },
    cancelAdd () {
      this.visible = false
      this.exceedReason = ''
    },
    // 填写领用原因
    handleSaveReason () {
      this.visible = false
    },
    handleAddress (id) {
      this.addressId = id + ''
    },
    // 手工增行
    addNew () {
      this.dataList.push({
        oldGoodsCode: '',
        oldGoodsName: '',
        oldSpecification: '',
        oldModel: '',
        oldRemark: '',
        goodsNum: '',
        oldEdition: '',
        oldConfiguration: '',
        safetyStockQuantity: '',
        goodsPrice: '',
        oldBrand: ''
      })
    },
    deleteHandle (row, index) {
      this.dataList.splice(index, 1)
    },
    // number(e){
    //   let flag = new RegExp('^[1-9]([0-9])*$').test(e.target.value)
    //   if (!flag){
    //     this.$message.error({
    //       message:'领用数量只能为正整数'
    //     })
    //   }
    // },
    getNameList () {
      this.$http
        .get(
          `${window.SITE_CONFIG['apiURL']}/lclb/receive/getSparePartsDetail`,
          {
            params: {
              customerCode: this.customerCode
            }
          }
        )
        .then((data) => {
          if (data.result.code === 0) {
            this.nameList = data.result.data
          } else {
            this.nameList = []
          }
        })
    },
    // 客户端领用新增时调用，如果报错不允许新增
    handleSaveReceive () {
      this.$http
        .get(`${window.SITE_CONFIG['apiURL']}/lclb/accountbill/checkPaid`, {
          params: {
            customerCode: this.customerCode
          }
        })
        .then((data) => {
          // 报错不允许新增
          if (data.result.code === 0) {
            this.handleSave()
          }
        })
    },
    // 确认
    handleSave () {
      if (this.subLoading) {
        return false
      }
      var flag = true
      if (this.oweFeeFlag === 1) {
        this.$message.error('企业已欠费，不能新增备件领用，请及时付款！')
        flag = false
      }
      // console.log(this.addressId)
      if (this.dataList.length === 0) {
        this.$message.warning('物品名称不能为空')
        flag = false
      }
      this.dataList.forEach((item) => {
        if (item.oldGoodsCode === '') {
          this.$message.warning('物品编码不能为空')
          flag = false
        }
        if (item.goodsNum === '') {
          this.$message.warning('领用数量不能为空')
          flag = false
        }
        if (!new RegExp('^[1-9]([0-9])*$').test(item.goodsNum)) {
          this.$message.warning('领用数量只能为大于0的正整数且不超过7位数')
          flag = false
        }
        if (
          !(
            item.oldGoodsName === '' ||
            item.oldGoodsName === undefined ||
            item.oldGoodsName === null
          )
        ) {
          if (!this.exceedReason) {
            // 超量原因为空
            if (item.goodsNum > item.safetyStockQuantity) {
              this.visible = true
              flag = false
            }
          } else {
            if (item.goodsNum <= item.safetyStockQuantity) {
              this.exceedReason = ''
            }
          }
        }
        if (
          item.oldGoodsName === '' ||
          item.oldGoodsName === undefined ||
          item.oldGoodsName === null
        ) {
          this.$message.warning('物品名称不能为空')
          flag = false
        }
      })
      if (this.visible === false) {
        if (
          this.dataForm.expectDeliveryDate === '' ||
          this.dataForm.expectDeliveryDate === null
        ) {
          this.$message.warning('期望领用日期不能为空')
          flag = false
        }
      }
      if (this.visible === false) {
        if (
          this.addressId === '' ||
          this.addressId === null ||
          this.addressId === undefined
        ) {
          this.$message.warning('地址不能为空')
          flag = false
        }
      }
      if (flag) {
        this.subLoading = true
        let params = {
          expectDeliveryDate: this.dataForm.expectDeliveryDate,
          orderRemarks: this.dataForm.remarks,
          addressId: this.addressId,
          expedited: this.dataForm.expedited,
          companyId: this.$store.state.user.company.companyId === undefined ? null : this.$store.state.user.company.companyId,
          excessMemo: this.exceedReason,
          receiveDetailList: this.dataList
        }
        this.$http.post(`/front/order/lclb/receive/saveByOrdinary`, {
          ...params,
          platformSource: 2
        })
          .then(({ data: res }) => {
            if (res.code === 0) {
              this.$message.success('新增成功')
              this.subLoading = false
              this.$router.push({ name: 'spareGetList' })
            } else {
              this.subLoading = false
            }
          })
          .catch(() => {
            this.subLoading = false
          })
      }
    },
    querySearchAsync (queryString, cb) {
      var array = []
      if (queryString && queryString.length > 1) {
        let params = {
          likeFlag: '1',
          oldGoodsCode: queryString,
          companyId: this.$store.state.user.company.companyId === undefined ? null : this.$store.state.user.company.companyId
        }
        this.$http.post(`/front/order/lclb/receive/getGoodsByOrdinary`, params)
          .then(({ data: res }) => {
            if (res.code === 0) {
              if (res.data && res.data.length > 0) {
                res.data.forEach((item) => {
                  item.value = item.codeSpeciModel
                })
                cb(res.data)
              } else {
                cb(array)
              }
            } else {
              cb(array)
            }
          })
      } else {
        cb(array)
      }
    },
    handleSelect (item, index) {
      this.dataList[index].oldConfiguration = item.oldConfiguration
      this.dataList[index].oldEdition = item.oldEdition
      this.dataList[index].oldGoodsCode = item.oldGoodsCode
      this.dataList[index].oldGoodsName = item.oldGoodsName
      this.dataList[index].oldModel = item.oldModel
      this.dataList[index].oldRemark = item.oldRemark
      this.dataList[index].oldSpecification = item.oldSpecification
      this.dataList[index].oldBrand = item.oldBrand
      this.dataList[index].goodsPrice = item.goodsPrice
      this.dataList[index].safetyStockQuantity = item.safetyStockQuantity
      this.dataList[index].goodsNum = item.safetyStockQuantityBef
      this.dataList[index].custspId = item.custspId
    },
    // 备件信息上传
    importInfo () {
      // this.$refs.inputer.click()
      this.$refs.fielUplod.$el.childNodes[0].childNodes[1].click()
    },
    // 导入成功
    fileSuccess (response, file, fileList) {
      if (response.data && response.code === 0) {
        this.$message.success(response.message)
        var totalList = [...this.dataList, ...response.data]
        this.dataList = totalList
      } else {
        this.errorContent = response.message
        this.importVisible = true
      }
    },
    // 导入失败
    fileError (file, fileList) {
      this.$message.error('导入失败，请重新上传')
    },
    // 模板下载
    downloadTemplate () {
      window.location.href = `${window.SITE_CONFIG['apiURL']}/front/consumer/templatedownload/importReceives?token=${getAccessToken()}`
    },
    // 导出失败
    handleExportFailed () {
      this.exportVisible = true
      this.handleExportSearch(1)
    },
    handleExportSearch (currentPage = this.currentPage) {
      this.currentPage = currentPage
      let params = {
        companyId: this.$store.state.user.company.companyId === undefined ? null : this.$store.state.user.company.companyId,
        page: currentPage,
        limit: 10
      }
      this.$http.post(`/front/order/lclb/receive/failListByOrdinary`, params)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.dataFailedList = res.data.data
            this.total = res.data.count
          } else {
            this.dataFailedList = []
            this.total = 0
          }
        })
    },
    cancelFail () {
      this.exportVisible = false
    },
    // 分页查询导出信息
    handleSizeChange (val) {
      this.handleExportSearch(1)
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.handleExportSearch()
    },
    // 导出失败记录
    handleFailExport () {
      axios({
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          token: 'Bearer ' + getAccessToken()
        },
        responseType: 'blob', // 一定要写
        url: `${window.SITE_CONFIG['apiURL']}/front/order/lclb/receive/failExport`
      })
        .then((res) => {
          let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
          let date = new Date()
          let month = date.getMonth() + 1
          let day = date.getDate()
          let fileName =
            '失败记录列表' +
            date.getFullYear() +
            (month >= 10 ? month : '0' + month) +
            (day >= 10 ? day : '0' + day) // 下载的文件名
          if ('msSaveOrOpenBlob' in navigator) {
            // 'IE'
            window.navigator.msSaveOrOpenBlob(blob, fileName + '.xls')
          } else {
            const link = document.createElement('a')
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            link.download = res.headers['content-disposition'] // 下载后文件名
            link.download = fileName
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
        })
        .catch(() => {
        })
    },
    handleChange (ind, a, index) {
      this.dataList[index].oldConfiguration = ''
      this.dataList[index].oldEdition = ''
      this.dataList[index].oldGoodsName = ''
      this.dataList[index].oldModel = ''
      this.dataList[index].oldRemark = ''
      this.dataList[index].oldSpecification = ''
      this.dataList[index].oldBrand = ''
      this.dataList[index].safetyStockQuantity = ''
      this.dataList[index].goodsPrice = ''
    },
    // 双击多选
    handledbClick (row, event, column) {
      // console.log(row.index, event, column)
      this.$refs.multipleTable.toggleRowSelection(row)
    },
    // 多选
    confirmPush () {
      var newList = []
      var flag = true
      this.dataListSelections.forEach((item) => {
        const {
          oldGoodsCode,
          oldGoodsName,
          oldSpecification,
          oldModel,
          oldRemark,
          safetyStockQuantity,
          custspId,
          oldConfiguration,
          oldEdition,
          oldBrand,
          goodsPrice
        } = item
        newList.push({
          oldGoodsCode,
          oldGoodsName,
          oldSpecification,
          oldModel,
          oldRemark,
          safetyStockQuantity,
          custspId,
          oldConfiguration,
          oldEdition,
          oldBrand,
          goodsPrice
        })
      })
      this.dataList.forEach((item) => {
        this.dataListSelections.forEach((data) => {
          if (data.oldGoodsCode === item.oldGoodsCode) {
            this.$message.warning('当前领用单已有同一种备件')
            flag = false
          }
        })
      })
      if (this.dataListSelections.length === 0) {
        this.$message.warning('请至少选择一条')
        flag = false
      }
      if (flag) {
        this.dataList.splice(this.currentIndex, 1)
        for (var i = 0; i < newList.length; i++) {
          this.dataList.push(newList[i])
          this.currentIndex++
        }
        this.dataList = [...this.dataList]
        this.searchVisible = false
      }
    },
    handleReset () {
      this.dataForm2 = {
        custGoodsCode: '',
        model: '',
        specification: '',
        goodsName: ''
      }
      this.handleCode()
    }
  }
}
</script>
<style scoped lang="scss">
/deep/ .el-input.is-disabled .el-input__inner {
  color: #000;
}
/deep/ .el-textarea.is-disabled .el-textarea__inner {
  color: #000;
}
.body-info h2 {
  font-size: 20px;
  color: #262626;
  margin-bottom: 20px;
}
.body-info {
  margin: 20px 0;
  width: 100%;
  padding: 30px 30px;
  background-color: #fff;
  word-wrap: break-word;
  word-break: break-all;
}
.row-opt-but {
  width: 161px;
  height: 50px;
  border: 1px solid #1d65a8;
  background-color: #fff;
  color: #1d65a8;
  font-size: 16px;
  line-height: 48px;
  text-align: center;
  cursor: pointer;
}
.row-opt-but:hover {
  background-color: #1d65a8;
  color: #fff;
}
.but-loading {
  opacity: 0.5;
  cursor: not-allowed;
}
.btns {
  margin-left: 230px;
}
.btn-check {
  margin-right: 30px;
}
.addressList {
  list-style: none;
}
.two-btns {
  margin-bottom: 10px;
}
.addFunc {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.addCancel {
  width: 158px;
  height: 48px;
  line-height: 48px;
  text-align: center;
  color: #1d65a8;
  border: 1px solid #1d65a8;
  margin-right: 10px;
  user-select: none;
  cursor: pointer;
}
.addConfirm {
  background-color: #1d65a8;
  color: #fff;
}
.spareInfo {
  line-height: 24px;
  font-size: 18px;
  color: #303133;
  font-weight: normal;
  margin-bottom: 20px;
  margin-top: 10px;
}
.inqueryDetail {
  .el-textarea {
    width: 100%;
    min-width: 500px;
  }
  .good-link {
    cursor: pointer;
    color: #1d65a8;
    text-decoration: underline;
  }
  /deep/ .el-form-item__label {
    flex-grow: 0;
    flex-shrink: 0;
  }
  /deep/ .el-form--inline .el-form-item,
  .el-form--inline .el-form-item__content {
    display: flex;
    word-break: break-all;
    word-wrap: break-word;
  }
}
.sjz {
  display: flex;
  justify-content: center;
  line-height: 40px;
  padding: 20px 70px;
  background-color: #fff;
}
.sjz-kuaikuai {
  display: flex;
  flex: 1;
}
.sjz-line {
  margin-top: 30px;
  flex: 1;
}
.sjz-item {
  width: 70px;
}
.sjz-icon {
  background: #ffffff;
  border: 1px solid #1d65a8;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  margin: 10px;
  margin-left: 15px;
  line-height: 38px;
  text-align: center;
  font-size: 20px;
  font-weight: 900;
}
.sjz-icon .sjc-num {
  line-height: 34px;
  font-size: 16px;
  font-weight: normal;
}
.sjz-undone {
  color: #cacaca;
  border: 1px solid #cacaca;
}
.sjz-do {
  background-color: #1d65a8;
  color: #fff;
}
.sjz-icon .el-icon-check {
  font-size: 30px;
  line-height: 38px;
  font-weight: 900;
  color: #1d65a8;
}
.sjz-word {
  /* padding-left: 10px; */
  color: #1d65a8;
  text-align: center;
  width: 100%;
}
.sjz-line {
  height: 2px;
  background: #1d65a8;
  width: 20px;
}
.goodsCode {
  position: relative;
}
.el-icon-search {
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -10px;
  cursor: pointer;
}
.downloadTem {
  margin-left: 20px;
  color: #1d65a8;
}
.downloadTem:hover {
  cursor: pointer;
}
.row-btn {
  margin-left: 875px;
  margin-bottom: 20px;
}
.close-but {
  background: #1d65a8;
  width: 160px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  color: #fff;
  font-size: 16px;
  margin: 0 auto;
}
</style>
<style>
.my-kqoption-spareGet {
  width: auto !important;
  max-width: 300px;
}
</style>
